function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.921 20.575a8 8 0 1 0-8-8 8.05 8.05 0 0 0 8 8zm-.178-6.389c-.5 0-.767-.24-.767-.7V13.4a1.834 1.834 0 0 1 .984-1.549c.689-.472 1.022-.72 1.022-1.231A.962.962 0 0 0 12.9 9.7a1.279 1.279 0 0 0-1.131.666l-.124.17a.783.783 0 0 1-.658.333.621.621 0 0 1-.635-.627 1.3 1.3 0 0 1 .077-.426A2.543 2.543 0 0 1 13 8.44c1.433 0 2.641.759 2.641 2.107 0 .937-.519 1.4-1.309 1.913-.527.341-.805.62-.836 1.038v.093a.683.683 0 0 1-.753.595zm-.016 2.463a.889.889 0 1 1 .953-.883.912.912 0 0 1-.953.883z",
  transform: "translate(-4.921 -4.575)"
});

function SvgQuestionFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionFilled);
export default __webpack_public_path__ + "static/media/question_filled.a6315354.svg";
export { ForwardRef as ReactComponent };